import api from '../utils/axiosConfig'
import { TierStatusList } from './getTierStatus'

export interface UnclaimedBonus {
  transaction_id: string
  amount: number
}

export interface UserProfile {
  user_id: string
  name: string
  lifetime_deposit: number
  tier: TierStatusList
  unclaimed_monthly_bonus?: UnclaimedBonus
  unclaimed_tier_bonus?: UnclaimedBonus
}

export const getProfile = async (user_id: string): Promise<UserProfile> => {
  try {
    const response = await api.get(`/user/profile`, {
      params: { user_id },
    })
    const data = response.data?.data
    if (!data) throw new Error('Empty user profile')

    return data
  } catch (error: any) {
    throw error
  }
}
